import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import type { UserRole } from '@/shared/types/tables';
import { ROUTES } from '@/shared/config/routes';
import { FullscreenLoader } from '@/shared/ui/feedback/FullscreenLoader';
import { useAuth } from '../useAuth';

/** Gate a route behind one or more roles; redirects home if the role is insufficient. */
export function RequireRole({ role, children }: { role: UserRole | UserRole[]; children: ReactNode }) {
  const { user, status } = useAuth();
  const allowed = Array.isArray(role) ? role : [role];

  if (status === 'loading') return <FullscreenLoader />;
  if (!user) return <Navigate to={ROUTES.auth} replace />;
  if (!allowed.includes(user.role)) return <Navigate to={ROUTES.home} replace />;
  return <>{children}</>;
}
